// extracted by mini-css-extract-plugin
export default {"products":"Iv-z","card":"Jv-z","oosMessaging":"Kv-z"};